import authContext from '../context/auth/authContext';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import contributionContext from '../context/contributions/contributionContext';
import memberContext from '../context/members/memberContext';
import moment from 'moment';

function Collection() {
  const navigate = useNavigate();
  const { logout, token, loadUser, user } = useContext(authContext);

  const { members, getMembers, clearMembers } = useContext(memberContext);
  const { contributions, getContributions, clearContributions } =
    useContext(contributionContext);
  const [all, setAll] = useState(true);
  const [searchDate, setSearchDate] = useState('');
  const [sortByH, setSortByH] = useState(null); // 'asc' | 'desc' | null

  const toggleSortByH = () => {
    if (sortByH === 'asc') setSortByH('desc');
    else setSortByH('asc');
  };

  let H, J, F, BH, BJ, BF, CH, CJ, CF;

  const filterByDate = (arr) =>
    arr.filter((c) => moment(c.weekDate).format('YYYY-MM-DD') === searchDate);

  if (all) {
    H = contributions?.reduce((total, con) => total + con.hisa, 0);
    J = contributions?.reduce((total, con) => total + con.jamii, 0);
    F = contributions?.reduce((total, con) => total + con.faini, 0);

    BH = contributions
      ?.filter((b) => b.type === 'Bank')
      .reduce((total, con) => total + con.hisa, 0);
    BJ = contributions
      ?.filter((b) => b.type === 'Bank')
      .reduce((total, con) => total + con.jamii, 0);
    BF = contributions
      ?.filter((b) => b.type === 'Bank')
      .reduce((total, con) => total + con.faini, 0);

    CH = contributions
      ?.filter((c) => c.type === 'Cash')
      .reduce((total, con) => total + con.hisa, 0);
    CJ = contributions
      ?.filter((c) => c.type === 'Cash')
      .reduce((total, con) => total + con.jamii, 0);
    CF = contributions
      ?.filter((c) => c.type === 'Cash')
      .reduce((total, con) => total + con.faini, 0);
  } else {
    const filtered = filterByDate(contributions || []);

    H = filtered.reduce((total, x) => total + x.hisa, 0);
    J = filtered.reduce((total, x) => total + x.jamii, 0);
    F = filtered.reduce((total, x) => total + x.faini, 0);

    BH = filtered
      .filter((b) => b.type === 'Bank')
      .reduce((total, x) => total + x.hisa, 0);
    BJ = filtered
      .filter((b) => b.type === 'Bank')
      .reduce((total, x) => total + x.jamii, 0);
    BF = filtered
      .filter((b) => b.type === 'Bank')
      .reduce((total, x) => total + x.faini, 0);

    CH = filtered
      .filter((cash) => cash.type === 'Cash')
      .reduce((total, x) => total + x.hisa, 0);
    CJ = filtered
      .filter((cash) => cash.type === 'Cash')
      .reduce((total, x) => total + x.jamii, 0);
    CF = filtered
      .filter((cash) => cash.type === 'Cash')
      .reduce((total, x) => total + x.faini, 0);
  }

  const Logout = () => {
    clearContributions();
    clearMembers();
    logout();
    navigate('/login');
  };

  const view = (id, name, no) => {
    navigate(`/contributions/${id}/${name}/${no}`);
  };

  const dateChange = (date) => {
    setSearchDate(date);
    setAll(false);
  };

  const getHValue = (memberId) => {
    const base = contributions?.filter((c) => c.memberId === memberId) || [];
    const data = all ? base : base.filter(
      (c) => moment(c.weekDate).format('YYYY-MM-DD') === searchDate
    );
    return data.reduce((total, x) => total + x.hisa, 0);
  };

  const sortedMembers = [...(members || [])].sort((a, b) => {
    if (!sortByH) return 0;
    const hA = getHValue(a._id);
    const hB = getHValue(b._id);
    return sortByH === 'asc' ? hA - hB : hB - hA;
  });

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
    document.title = 'Collection';
    getMembers();
    getContributions();
    loadUser();
  }, [token]);

  return (
    <>
      <div className='member-header'>
        <div>
          <p>{user && `${user.name}`}</p>
        </div>
        <section className='logout'>
          <span onClick={Logout}>Log Out</span>
        </section>
      </div>
      <section className='collection-heading heading '>
        <h5>Amani Group({user && `${user.groupId}`}) </h5>
        <div className='heading-total'>
          <div className='total'>
            <p className='hisa'>{`H: ${H?.toLocaleString()}`}</p>
            <p className='jamii'>{`J: ${J?.toLocaleString()}`}</p>
            <p className='faini'>{`F: ${F?.toLocaleString()}`}</p>
          </div>
          <div className='total-search'>
            <div className='date-label'>
              <label htmlFor='day'>Search by date</label>
              <input
                type='date'
                name='day'
                id='day'
                value={searchDate}
                onChange={(e) => dateChange(e.target.value)}
              />
            </div>
            <button
              onClick={() => {
                setAll(true);
                setSearchDate('');
                setSortByH(null); // 🆕 Reset sorting when All is clicked
              }}
              className={all ? 'all-true' : 'all-false'}
            >
              All
            </button>
          </div>
          <div className='total'>
            <p className='hisa'>{`BH: ${BH?.toLocaleString()}`}</p>
            <p className='jamii'>{`BJ: ${BJ?.toLocaleString()}`}</p>
            <p className='faini'>{`BF: ${BF?.toLocaleString()}`}</p>
            <p className='hisa'>{`CH: ${CH?.toLocaleString()}`}</p>
            <p className='jamii'>{`CJ: ${CJ?.toLocaleString()}`}</p>
            <p className='faini'>{`CF: ${CF?.toLocaleString()}`}</p>
          </div>
        </div>
      </section>

      <section className='collection-content'>
        <table className='table table-striped '>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th onClick={toggleSortByH} style={{ cursor: 'pointer' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px', // spacing between H and the box
                  }}
                >
                  <span>H</span>
                  <span
                    style={{
                      border: '1px solid red',
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {sortByH === 'asc' ? '🔼' : sortByH === 'desc' ? '🔽' : ''}
                  </span>
                </div>
              </th>
              <th>J</th>
              <th>F</th>
              <th>
                <i className='fa-brands fa-buffer'></i>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedMembers.map((member) => {
              const memberContributions = contributions?.filter(
                (c) => c.memberId === member._id
              );
              const filtered = all
                ? memberContributions
                : memberContributions?.filter(
                  (c) =>
                    moment(c.weekDate).format('YYYY-MM-DD') === searchDate
                );

              const hisa = filtered?.reduce((sum, x) => sum + x.hisa, 0) || 0;
              const jamii = filtered?.reduce((sum, x) => sum + x.jamii, 0) || 0;
              const faini = filtered?.reduce((sum, x) => sum + x.faini, 0) || 0;
              const types = filtered?.map((c) => c.type);

              if (!all && hisa === 0) return null;

              return (
                <tr key={member._id}>
                  <td>{member.memberno}</td>
                  <td>{member.name}</td>
                  <td>
                    {hisa.toLocaleString()}
                    {types?.includes('Bank')
                      ? 'B'
                      : types?.includes('Cash')
                        ? 'C'
                        : ''}
                  </td>
                  <td>
                    {jamii.toLocaleString()}
                    {types?.includes('Bank')
                      ? 'B'
                      : types?.includes('Cash')
                        ? 'C'
                        : ''}
                  </td>
                  <td>
                    {faini.toLocaleString()}
                    {types?.includes('Bank')
                      ? 'B'
                      : types?.includes('Cash')
                        ? 'C'
                        : ''}
                  </td>
                  <td
                    onClick={() =>
                      view(member._id, member.name, member.memberno)
                    }
                    className='view'
                  >
                    <i className='fa-solid fa-eye'></i>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </>
  );
}

export default Collection;